import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

export const SESSION_FIELDS = [
  { key: "startTime", label: "Session Start" },
  { key: "endTime", label: "Session End" },
  { key: "authType", label: "Authentication" },
  { key: "sessionDurationFormatted", label: "Session Duration" },
  { key: "activeChargeTimeFormatted", label: "Active Charge Time" },
  { key: "aggEnergyValue", label: "Energy Added", unit: "kWh" },
  { key: "aggEnergyDischargeValue", label: "Energy Discharged", unit: "kWh", bidiOnly: true },
  { key: "milesAdded", label: "Range Added", unit: "mi" },
  { key: "sessionCost", label: "Session Cost", prefix: "$" },
  { key: "avgCostPerUnitEnergy", label: "Cost per kWh", prefix: "$", unit: "/kWh" },
];

export const CHART_BAR_COLOR = "#3b82f6";
export const CHART_LINE_COLOR = "#f59e0b";

export function formatSessionTime(isoString, timezone) {
  if (!isoString) return "—";
  const cleaned = isoString.includes("[") ? isoString.substring(0, isoString.indexOf("[")) : isoString;
  const d = timezone ? dayjs(cleaned).tz(timezone) : dayjs(cleaned);
  return d.format("MMM D, YYYY h:mm A");
}

export function formatSessionValue(field, value) {
  if (value === null || value === undefined || value === "") return "N/A";
  if (field.prefix && field.unit) return `${field.prefix}${value}${field.unit}`;
  if (field.prefix) return `${field.prefix}${value}`;
  if (field.unit) return `${value} ${field.unit}`;
  return String(value);
}

export function getEnergyColor(energy) {
  if (!energy || energy <= 0) return "#9ca3af";
  if (energy >= 30) return "#10b981";
  if (energy >= 10) return "#3b82f6";
  return "#8b5cf6";
}

export function formatDurationCompact(seconds) {
  if (!seconds || seconds <= 0) return "—";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}
